<template>
  <v-tooltip v-if="text" :left="!right" :right="right" max-width="250">
    <template v-slot:activator="{ on, attrs }">
      <v-icon
        color="blue"
        v-bind="attrs"
        v-on="on"
        style="background-color: white; border-radius: 9999px;"
      >{{icon}}</v-icon>
    </template>
    <span>{{text}}</span>
  </v-tooltip>
</template>

<script>
export default {
  props: {
    right: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: ""
    },
    icon: {
      type: String,
      default: "mdi-information"
    }
  }
};
</script>

<style lang="scss" scoped>
</style>